import {LitElement, css, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { GetFormattedDate } from '../../../src/utils/helpers';
import { TooltipFormatterParams } from './echarts-options';

interface TooltipValue
{
    color: string;
    name: string;
    current: number|null;
    range?: {
        lower: number;
        upper: number;
    }
    directionValue?: number|null
}


export enum TooltipType {
    standart = "Standart",
    weather = "Weather"
}
@customElement('voy-timeseries-chart-tooltip')
export class VoyTimeseriesChartTooltip extends LitElement
{
    @property({ type: Array }) params: TooltipFormatterParams[]|null = null;
    @property({ type: String }) unit: string = "";
    @property({}) tooltipType: TooltipType = TooltipType.standart
    
    static get styles() {
        return [
            css`
            :host {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                font-family: 'MaerskText';
                font-size: 10px;
                line-height: 12px;
                color: white;
                background: var(--primary-blue-01, darkblue);
                padding: 5px 10px;
                border-radius: 2px;
            }

            .values {
                display: grid;
                grid-template-columns: auto auto auto;
                justify-content: center;
                align-items: center;
                column-gap: 7px;
            }

            .withRange {
                grid-template-columns: auto auto auto auto;
            }

            .legend {
                width: 11px;
                height: 2px;
            }
        `];
    }

    render()
    {
        if (!this.params)
        {
            return html`No data`;
        }

        const values = this._processParams();
        
        if (!values.length || !this._hasValues(values)) {
            return html`No data`;
        }
        
        if(this.tooltipType === TooltipType.weather) {
            return html`
                <div>${GetFormattedDate(this.params[0].value[0])}</div>
                <div class="values withRange">
                    <div></div><div></div><div>Current</div><div>Direction</div>
                    ${values.map( value => {
                        if (typeof value.current !== 'number') {
                            return html``;
                        }
                        // debugger;
                        return html`
                            <div class="legend" style=${`background: ${value.color}`}></div>
                            <div>${value.name}</div>
                            <div>${value.current} ${this.unit}</div>
                            <div>${typeof (value.directionValue) === 'number' ? value.directionValue + "°" : "--"}</div>
                        `
                    })}
                </div>
            `
        }
        return html`
        <div>${GetFormattedDate(this.params[0].value[0])}</div>
        <div class="values ${this._showRange ? 'withRange' : ''}">
            <div></div><div></div><div>Current</div>${this._showRange ? html`<div>Range</div>` : html``}
            ${values.map( value => {
                if (typeof (value.current) !== 'number') {
                    return;
                }
                return html`
                <div class="legend" style=${`background: ${value.color}`}></div>
                <div>${value.name}</div>
                <div>${value.current} ${this.unit}</div>
                ${this._showRange ? html`
                <div>${value.range ? `${value.range.lower} - ${value.range.upper} ${this.unit}`: ""}</div>
                ` : html``}
                `
            })}
        </div>
        `;
    }

    // check if there are any values to show (they might all be null)
    private _hasValues(values: TooltipValue[]) {
        for (const value of values) {
            if (value.current !== null) {
                return true;
            }
        }
        return false;
    }

    private _showRange: boolean = false;

    private _processParams(): TooltipValue[]
    {
        const result: TooltipValue[] = [];

        const lowerUpperParams: TooltipFormatterParams[] = [];
        const valueParams: TooltipFormatterParams[] = [];

        for (const param of this.params!)
        {
            if (param.seriesName === "timestampFiller") {
                continue;
            }
            if (param.seriesName.endsWith("_lower") || param.seriesName.endsWith("_upper"))
            {
                lowerUpperParams.push(param);
            } else
            {
                valueParams.push(param);
            }
        }

        this._showRange = lowerUpperParams.length > 0;
        
        for (const valueParam of valueParams)
        {
            const tooltipValue: TooltipValue = {
                color: valueParam.color,
                name: valueParam.seriesName,
                current: valueParam.value[1],

            };

            if (this._showRange)
            {
                // Check if we have a range for this series
                const lowerParam = lowerUpperParams.find( param => param.seriesName === `${tooltipValue.name}_lower` );
                const upperParam = lowerUpperParams.find( param => param.seriesName === `${tooltipValue.name}_upper` );

                if (lowerParam && upperParam)
                {
                    tooltipValue.range = {
                        lower: lowerParam.value[1],
                        upper: upperParam.value[1] + lowerParam.value[1]
                    }
                }
            }

            if(this.tooltipType === TooltipType.weather) {
                tooltipValue.directionValue = valueParam.directionValue;
            }

            result.push(tooltipValue);
        }

        return result;
    }
}
